import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxPaginationModule } from 'ngx-pagination';
import { PipesModule } from '../comum/filtros/pipes/pipes.module';
import { ComumModule } from '../comum/comum.module';
import { routing } from '../rotas';
import { ModalRotinasClienteComponent } from './modal-rotinas-cliente/modal-rotinas-cliente.component';
import { CadastroRotinaComponent } from './cadastro-rotina/cadastro-rotina.component';
import { ListarProcessosSetoresComponent } from './listar-processos-setores/listar-processos-setores.component';
import { ListarRotinasClienteComponent } from './listar-rotinas-cliente/listar-rotinas-cliente.component';
import { SelecaoRotinasClienteComponent } from './selecao-rotinas-cliente/selecao-rotinas-cliente.component';
import { RotinaTabsetComponent } from './rotina-tabset/rotina-tabset.component';
import { FormsModule } from '@angular/forms';
import { RotinaService } from './rotina.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LoadingModule, ANIMATION_TYPES } from 'ngx-loading';
import { ConfirmDialogModule, ConfirmationService, CalendarModule, MultiSelectModule } from 'primeng/primeng';
import { ModalSetoresRotinaComponent } from './modal-setores-rotina/modal-setores-rotina.component';
import { ModalPontosFisicosRotinaComponent } from './modal-pontos-fisicos-rotina/modal-pontos-fisicos-rotina.component';
import { SetorModule } from '../setor/setor.module';
import { ListarPontosFisicosRotinaComponent } from './listar-pontos-fisicos-rotina/listar-pontos-fisicos-rotina.component';
import { ListarSetoresRotinaComponent } from './listar-setores-rotina/listar-setores-rotina.component';
import { CookieService } from 'angular2-cookie/services/cookies.service';
import { ModalReincidenciaRotinaComponent } from './modal-reincidencia-rotina/modal-reincidencia-rotina.component';
import { ReincidenciaRotinaComponent } from './reincidencia-rotina/reincidencia-rotina.component';
import { PesquisaReincidenciaComponent } from './pesquisa-reincidencia/pesquisa-reincidencia.component';
import { ListaReincidenciasComponent } from './lista-reincidencias/lista-reincidencias.component';
import { OcorrenciasModule } from '../ocorrencias/ocorrencias.module';

@NgModule({
  imports: [
    CommonModule,
    NgxPaginationModule,
    NgbModule,
    PipesModule,
    ComumModule,
    SetorModule,
    routing,
    FormsModule,
    ConfirmDialogModule,
    CalendarModule,
    MultiSelectModule,
    OcorrenciasModule,
    LoadingModule.forRoot({
      animationType: ANIMATION_TYPES.circle
    })
  ],
  declarations: [CadastroRotinaComponent, ListarProcessosSetoresComponent,
    ListarRotinasClienteComponent, ModalRotinasClienteComponent,
    SelecaoRotinasClienteComponent, RotinaTabsetComponent, ModalSetoresRotinaComponent, ModalPontosFisicosRotinaComponent,
    ListarPontosFisicosRotinaComponent, ListarSetoresRotinaComponent, ModalReincidenciaRotinaComponent,
      ReincidenciaRotinaComponent, PesquisaReincidenciaComponent, ListaReincidenciasComponent],
  exports: [CadastroRotinaComponent, ListarProcessosSetoresComponent,
    ListarRotinasClienteComponent, ModalRotinasClienteComponent,
    SelecaoRotinasClienteComponent, RotinaTabsetComponent, ModalSetoresRotinaComponent, ModalPontosFisicosRotinaComponent,
    ListarPontosFisicosRotinaComponent, ListarSetoresRotinaComponent, ModalReincidenciaRotinaComponent,
    ReincidenciaRotinaComponent, PesquisaReincidenciaComponent, ListaReincidenciasComponent],
  providers: [RotinaService, ConfirmationService, CookieService]
})
export class RotinaModule { }



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/rotina/rotina.module.ts